import { render, staticRenderFns } from "./NewDecoratorFullScreen.vue?vue&type=template&id=908483de&scoped=true&"
import script from "./NewDecoratorFullScreen.vue?vue&type=script&lang=js&"
export * from "./NewDecoratorFullScreen.vue?vue&type=script&lang=js&"
import style0 from "./NewDecoratorFullScreen.vue?vue&type=style&index=0&id=908483de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908483de",
  null
  
)

export default component.exports